import { METHODS, request } from '../axiosInstances';

export default {
  get: (params = {}) => request(METHODS.GET, `/channels/`, { params }),
  update: (params: Record<string, unknown>) => request(METHODS.PUT, `/channels/`, { params }),
  getURL: (params = {}) => request(METHODS.GET, `/channels/export/`, { params }),
};
